import { render, staticRenderFns } from "./TripListItem.vue?vue&type=template&id=50bb5442&scoped=true&"
import script from "./TripListItem.vue?vue&type=script&lang=js&"
export * from "./TripListItem.vue?vue&type=script&lang=js&"
import style0 from "./TripListItem.vue?vue&type=style&index=0&id=50bb5442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb5442",
  null
  
)

/* custom blocks */
import block0 from "./TripListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports